/**
 *
 *
 *
 */
const init = function () {
	setupToggler();
};


/**
 *
 *
 *
 */
const setupToggler = function () {

	const togglers = document.querySelectorAll('.apm-quiz-js-toggler');

	if (togglers.length === 0) {
		return;
	}

	Array.prototype.forEach.call(togglers, trigger => {

		const targetReference = trigger.getAttribute('data-target');
		const target = document.getElementById(targetReference);
		const scrollToReference = trigger.getAttribute('data-scroll-to');
		const scrollTo = document.getElementById(scrollToReference);

		trigger.onclick = () => {
			const expanded = trigger.getAttribute('aria-expanded') === 'true' || false;
			trigger.setAttribute('aria-expanded', !expanded);
			target.hidden = expanded;

			if (scrollTo) {
				$('html, body').animate({
					scrollTop: $(scrollTo).offset().top
				}, 500);
			}

		};

	});

};


const api = {
	init: init
};

export default api;